import { Button } from '@radix-ui/themes';
import { EyeOpenIcon } from '@radix-ui/react-icons';

interface ViewButtonProps {
  onClick?: () => void;
  href?: string;
}

const ViewButton = ({ onClick, href }: ViewButtonProps) => (
  <Button variant="ghost" size="1" onClick={onClick} asChild={!!href}>
    {href ? (
      <a href={href}>
        <EyeOpenIcon width={12} height={12} />
        View
      </a>
    ) : (
      <>
        <EyeOpenIcon width={12} height={12} />
        View
      </>
    )}
  </Button>
);

export default ViewButton;
